var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23483 4.73483C2.38128 4.58839 2.61872 4.58839 2.76517 4.73483L6 7.96967L9.23483 4.73484C9.38128 4.58839 9.61872 4.58839 9.76516 4.73484C9.91161 4.88128 9.91161 5.11872 9.76516 5.26517L6.26516 8.76516C6.19484 8.83549 6.09946 8.875 6 8.875C5.90054 8.875 5.80516 8.83549 5.73483 8.76516L2.23483 5.26517C2.08839 5.11872 2.08839 4.88128 2.23483 4.73483Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select_arrow.3a42fbabafa24c903a79366bbd1cb139.svg";
export { ForwardRef as ReactComponent };